var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        empty: !_vm.comments.length,
      },
    },
    [
      _vm.comments.length
        ? _vm._l(_vm.comments, function (comment) {
            return _c("comment", {
              key: comment.id,
              attrs: {
                entity: _vm.entity,
                "entity-id": _vm.entityId,
                comment: comment,
                "can-edit": _vm.canEdit,
                "active-form": _vm.activeForm,
              },
              on: {
                formOpened: function ($event) {
                  return _vm.$emit("formOpened", $event)
                },
                commentAdded: function ($event) {
                  return _vm.$emit("commentAdded", $event)
                },
                commentUpdated: function ($event) {
                  return _vm.$emit("commentUpdated", $event)
                },
                commentRemoved: function ($event) {
                  return _vm.$emit("commentRemoved", $event)
                },
                commentRestored: function ($event) {
                  return _vm.$emit("commentRestored", $event)
                },
              },
            })
          })
        : [
            _c("div", { staticClass: "not-found" }, [
              _vm._v("Комментариев пока нет"),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }